<template>
  <IconListItem v-if="date" icon="calendar" :label="label ?? $t('common.words.drawing')">
    <time class="text-capitalize" :datetime="date.toString()">
      {{ formatDate(date, 'drawing', undefined, locale) }}
    </time>
  </IconListItem>
</template>

<script lang="ts" setup>
import IconListItem from '~/components/IconList/IconListItem.vue'

export type IconListItemDateProps = {
  date?: Date | string
  label?: string
}

defineProps<IconListItemDateProps>()

const { locale } = useI18n()
</script>
